import { connectedStore } from '../../store';
import removeElementAttributeAction from '../actions/remove-element-attribute';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const removeElementAttribute = (elementId, attr, options) => {
  const store = connectedStore.get();
  store.dispatch(removeElementAttributeAction(elementId, attr, options));
};

removeElementAttribute[USED_ACTION_CREATOR] = removeElementAttributeAction;

export default removeElementAttribute;
